import { PartnerDashboardState } from 'src/modules/partner-dashboard/types/PartnerDashboardState';
import { RootState } from 'src/types/RootState';

export function getPartnerDashboardState(state: RootState): PartnerDashboardState {
  return state.partnerDashboard;
}
